import { render, staticRenderFns } from "./ExamCreate.vue?vue&type=template&id=539f45c6"
import script from "@/controllers/custom/exam/exam-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/exam/exam-create.js?vue&type=script&lang=js&external"
import style0 from "./ExamCreate.vue?vue&type=style&index=0&id=539f45c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports